import { createAction } from '@reduxjs/toolkit';

export const budgetMockInit = createAction('BUDGET_MOCK_INIT');
export const resetProposal = createAction('RESET_PROPOSAL');
export const resetItemProposal = createAction('RESET_ITEM_PROPOSAL');
export const updateItemComment = createAction('UPDATE_ITEM_COMMENT');
export const updateItemAmount = createAction('UPDATE_ITEM_AMOUNT');
export const updateSubitemAmount = createAction('UPDATE_SUBITEM_AMOUNT');
export const balanceBudget = createAction('BALANCE_BUDGET');
